import {
  Table,
  Button,
  Divider,
  DatePicker,
  Row,
  Col,
  Popover,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';

const { RangePicker } = DatePicker;

import React from 'react';
import moment from 'moment';

class TablaRegistrosEntradasSalidas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.certificaciones,
      textoBuscarNombre: props.textoFiltroNombre ? props.textoFiltroNombre : '',
      textoBuscarApellido: props.textoFiltroApellido
        ? props.textoFiltroApellido
        : '',
      textoBuscarDocumento: props.textoFiltroDocumento
        ? props.textoFiltroDocumento
        : '',
      filtered: false,
    };
  }

  onInputChange = e => {
    this.setState({ textoBuscarNombre: e.target.value });
  };

  onApellidoChange = e => {
    this.setState({ textoBuscarApellido: e.target.value });
  };

  onDocumentoChange = e => {
    this.setState({ textoBuscarDocumento: e.target.value });
  };

  descargar = () => {
    this.props.onDescargar();
  };

  render() {
    const columns = [
      {
        title: 'Fecha Recepcion',
        dataIndex: 'fechaRecepcion',
        key: 'fechaRecepcion',
        render: fecha => (fecha ? moment(fecha).format('DD/MM/YYYY') : '-'),
        align: 'center',
      },
      {
        title: 'Fecha Devolucion',
        dataIndex: 'fechaDevolucion',
        key: 'fechaDevolucion',
        render: fecha => (fecha ? moment(fecha).format('DD/MM/YYYY') : '-'),
        align: 'center',
      },
      {
        title: 'Organismo Origen',
        dataIndex: 'organismoOrigen',
        key: 'organismoOrigen',
        align: 'center',
      },
      {
        title: 'Descripcion',
        dataIndex: 'descripcion',
        key: 'descripcion',
        render: descripcion => (
          <Popover content={descripcion} title="Descripcion">
            {descripcion.length > 60
              ? descripcion.slice(0, 60).concat('...')
              : descripcion}
          </Popover>
        ),
        align: 'center',
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              size="small"
              icon={<Icons.FileTextOutlined />}
              onClick={() => this.props.abrirModalAsignar(record._id)}
              disabled={
                (record.oficioSalida && record.oficioSalida._id) ||
                (record.documentoSalida && record.documentoSalida._id)
              }
            />
            <Divider type="vertical" />
            {record.oficioSalida && (
              <Button
                size="small"
                // type="primary"
                disabled={!(record.oficioSalida && record.oficioSalida._id)}
                icon={<Icons.PrinterOutlined />}
                onClick={() => this.props.imprimir(record.oficioSalida)}
              />
            )}
            {record.documentoSalida && (
              <Button
                size="small"
                // type="primary"
                disabled={
                  !(record.documentoSalida && record.documentoSalida._id)
                }
                icon={<Icons.PrinterOutlined />}
                onClick={() => this.props.imprimir(record.documentoSalida)}
              />
            )}
            <Divider type="vertical" />
            <Button
              size="small"
              type="primary"
              icon={<Icons.EditOutlined />}
              onClick={() =>
                this.props.history.push(
                  `/admin/registrosEntradasSalidas/${record._id}`
                )
              }
            />
            <Divider type="vertical" />
            <Button
              size="small"
              type="danger"
              icon={<Icons.DeleteOutlined />}
              onClick={() => this.props.onDelete(record._id)}
            />
          </span>
        ),
      },
    ];
    const { registroEntradaSalida } = this.props;

    const paginationOptions = {
      onChange: page => {
        this.props.cambiarPagina(page);
      },
      total: this.props.total,
      current: this.props.pagina,
      pageSize: this.props.cantidadPorPagina,
      pageSizeOptions: ['2', '5', '10', '20', '50'],
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, pageSize) => {
        this.props.cambiarTamañoPagina(pageSize);
        this.props.cambiarPagina(1);
      },
    };

    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={paginationOptions}
        loading={this.props.loadingTabla}
        dataSource={registroEntradaSalida}
        title={() => (
          <div>
            {' '}
            <h2 style={{ textAlign: 'center' }}>
              {' '}
              Registros Entrada y/o Salida{' '}
            </h2>
            <div style={{ textAlign: 'center' }}>
              {' '}
              <Row>
                <Col span={6}>
                  Cantidad Total de Registros: {this.props.total}
                </Col>
                <Col span={12}>
                  <RangePicker
                    onChange={this.props.onChange}
                    defaultValue={
                      this.props.fechaInicio && this.props.fechaFin
                        ? [
                            moment(this.props.fechaInicio),
                            moment(this.props.fechaFin),
                          ]
                        : [moment().subtract(7, 'd'), moment()]
                    }
                    format={'DD-MM-YYYY'}
                  />
                </Col>{' '}
              </Row>
            </div>{' '}
          </div>
        )}
        locale={{
          emptyText: 'Sin Registros de Entrada y/o Salida cargados.',
        }}
      />
    );
  }
}

export default TablaRegistrosEntradasSalidas;
